import { SpanCardShimmer } from "../../Cards";

const SPAN_CARD_SHIMMER_KEYS = Array.from(
  { length: 20 },
  (_, index) => `span-card-shimmer-${index + 1}`,
);
const SHIMMER_STAGGER_DELAY_MS = 55;

const SpansLoadingShimmer = () => (
  <>
    {SPAN_CARD_SHIMMER_KEYS.map((key, index) => (
      <SpanCardShimmer key={key} animationDelayMs={index * SHIMMER_STAGGER_DELAY_MS} />
    ))}
  </>
);

export default SpansLoadingShimmer;
